import * as React from 'react';

import { ModalPhases } from './ShareModal.models';
import { EmailFormModal } from './components/EmailFormModal';
import { ShareModal } from './components/Modal';
import { PasswordFormModal } from './components/PasswordFormModal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (email: string) => void;
  onPasswordSubmit: (password: string) => void;
  onRemove: () => void;
  hasPassword: boolean;
  shareableUrl: string;
  modalTitle: string;
  descriptionText: string;
}

export const SharePageModal: React.VFC<Props> = ({
  isOpen = false,
  onClose,
  onSubmit,
  onRemove,
  onPasswordSubmit,
  hasPassword,
  shareableUrl,
  modalTitle,
  descriptionText,
}) => {
  const [form, setForm] = React.useState<ModalPhases>(ModalPhases.EMAIL);
  const inputRef = React.useRef<HTMLInputElement>(null);

  const handlePasswordRemove = async () => {
    await onRemove();

    setForm(ModalPhases.EMAIL);
  };

  const handleAddPassword = () => {
    setForm(ModalPhases.PASSWORD);
  };

  const handlePasswordCancel = () => {
    setForm(ModalPhases.EMAIL);
  };

  const handlePasswordConfirm = async (password: string) => {
    await onPasswordSubmit(password);

    setForm(ModalPhases.EMAIL);
  };

  const handleClose = () => {
    setForm(ModalPhases.EMAIL);

    onClose();
  };

  return (
    <ShareModal
      isOpen={isOpen}
      onClose={handleClose}
      initialFocusRef={inputRef}
      modalContentProps={{ padding: 6 }}
    >
      {form === ModalPhases.EMAIL && (
        <EmailFormModal
          descriptionText={descriptionText}
          hasPassword={hasPassword}
          initialFocusRef={inputRef}
          modalTitle={modalTitle}
          onAddPassword={handleAddPassword}
          onCancel={handleClose}
          onSubmit={onSubmit}
          shareableUrl={shareableUrl}
        />
      )}
      {form === ModalPhases.PASSWORD && (
        <PasswordFormModal
          onCancel={handlePasswordCancel}
          onSubmit={handlePasswordConfirm}
          hasPassword={hasPassword}
          onRemove={handlePasswordRemove}
        />
      )}
    </ShareModal>
  );
};
